import script from "./DriversWithPotentiallyExcessiveHoursDetailModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DriversWithPotentiallyExcessiveHoursDetailModal.vue?vue&type=script&setup=true&lang=ts"

import "./DriversWithPotentiallyExcessiveHoursDetailModal.vue?vue&type=style&index=0&id=2dc198ae&lang=css"

const __exports__ = script;

export default __exports__